<template>
	<div class="com-container">
		<div class="com-chart" ref="hot_ref"></div>
	</div>
</template>

<script>
	import axios from "axios";
	export default {
		data() {
			return {
				chartInstance: null,
				allData: null,
			};
		},
		computed: {

		},
		mounted() {
			this.initChart();
			this.getData();
			window.addEventListener("resize", this.screenAdapter);
			// 在页面加载完成的时候, 主动进行屏幕的适配
			this.screenAdapter();
		},
		destroyed() {
			// 在组件销毁的时候, 需要将监听器取消掉
			window.removeEventListener("resize", this.screenAdapter);
		},
		methods: {
			initChart() {
				this.chartInstance = this.$echarts.init(
					this.$refs.hot_ref,
					"chalk"
				);
				const initOption = {
					legend: {
						right: "3%",
						top: 20,
						icon: "rect",
						orient: "vertical",
						textStyle: {
							color: "#fff",
							fontSize: 13
						}
					},
					tooltip: {
						show: true,
					},
					series: [
						{
							type: 'pie',
							radius: ['40%', '70%'],
							center: ['35%', '50%'],
							avoidLabelOverlap: false,
							itemStyle: {
								borderRadius: 10,
								// borderColor: '#fff',
								// borderWidth: 2
							},
							emphasis: {
								label: {
									show: true,
									fontSize: 20,
									fontWeight: 'bold'
								}
							},
							labelLine: {
								show: false
							},
						},
					],
				};
				this.chartInstance.setOption(initOption);
			},
			async getData() {
				const { data: ret } = await axios.get("/left-middle-two")
				this.allData = ret.data;
				this.updateChart();
			},
			updateChart() {
				let seriesData = this.allData.map(
					(item) => {
						return {
							name: item.name,
							value: item.value,
						};
					}
				);
				const legendData = this.allData.map(
					(item) => {
						return {
							name: item.name,
						};
					}
				);
				const dataOption = {
					color: ['#617FEB', '#59AED3', '#B55AFF', '#EECC32', '#27BF99', '#EEDD78', '#59AED3'],
					legend: {
						data: legendData,
					},
					series: [
						{
							data: seriesData,
						},
					],
				};
				this.chartInstance.setOption(dataOption);
			},
			screenAdapter() {
				const titleFontSize = (this.$refs.hot_ref.offsetWidth / 100) * 3.6;
				this.titleFontSize = titleFontSize;
				const adapterOption = {
					title: {
						textStyle: {
							fontSize: this.titleFontSize,
						},
					},
					legend: {
						itemWidth: this.titleFontSize / 2,
						itemHeight: this.titleFontSize / 2,
						itemGap: this.titleFontSize / 2,
						textStyle: {
							// fontSize: this.titleFontSize / 1.5,
							fontSize: 13
						},
					},
					series: [
						{
							radius: this.titleFontSize * 4.5,
							radius: ['40%', '70%'],
						},
					],
				};
				this.chartInstance.setOption(adapterOption);
				// 手动的调用图表对象的resize 才能产生效果
				this.chartInstance.resize();
			},

			toLeft() {
				this.currentIndex--;
				if (this.currentIndex < 0) {
					this.currentIndex = this.allData.length - 1;
				}
				this.updateChart();
			},
			toRight() {
				this.currentIndex++;
				if (this.currentIndex > this.allData.length - 1) {
					this.currentIndex = 0;
				}
				this.updateChart();
			},
		},
	};
</script>

<style lang='less' scoped>
	.arr-left {
		position: absolute;
		left: 10%;
		top: 50%;
		transform: translateY(-50%);
		cursor: pointer;
		color: white;
	}

	.arr-right {
		position: absolute;
		right: 10%;
		top: 50%;
		transform: translateY(-50%);
		cursor: pointer;
		color: white;
	}

	.cat-name {
		position: absolute;
		left: 80%;
		bottom: 20px;
		color: white;
	}
</style>